import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Dumbbell, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [busy, setBusy] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        if (!email.includes("@")) {
            toast.error("Enter a valid email");
            return;
        }
        setBusy(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Could not send reset link");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-4 py-12">
            <div className="w-full max-w-md">
                <Link to="/login" data-testid="fp-back" className="mb-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-white/60 hover:text-white">
                    <ArrowLeft className="h-3.5 w-3.5" /> Back to sign in
                </Link>
                <div className="flex items-center gap-2">
                    <Dumbbell className="h-6 w-6 text-accent-red" />
                    <span className="font-display text-2xl font-black uppercase">Hyper<span className="text-accent-red">gains</span></span>
                </div>
                <h1 className="mt-8 font-display text-4xl font-black uppercase">Forgot password?</h1>
                <p className="mt-2 text-sm text-white/65">
                    Drop your email — we'll send a reset link that works for 60 minutes.
                </p>
                {sent ? (
                    <div className="mt-8 border border-accent-red/40 bg-accent-red/5 p-5" data-testid="fp-sent">
                        <div className="label-eyebrow text-accent-red">Check your inbox</div>
                        <p className="mt-2 text-sm text-white/85">
                            If <strong>{email}</strong> is registered, a reset link is on its way. The link expires in 60 minutes.
                        </p>
                        <p className="mt-3 text-xs text-white/55">
                            Didn't get it? Check your spam folder, or contact support and we'll send a manual link.
                        </p>
                        <button onClick={() => navigate("/login")} data-testid="fp-done" className="mt-5 w-full rounded-sm bg-accent-red px-4 py-3 text-xs font-bold uppercase tracking-wider hover:bg-[color:var(--accent-hover)]">
                            Back to sign in
                        </button>
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-8 space-y-3" data-testid="fp-form">
                        <label className="label-eyebrow text-white/60">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="fp-email"
                            className="w-full rounded-sm border border-white/20 bg-black/30 px-3 py-3 text-sm focus:border-accent-red focus:outline-none"
                            placeholder="you@somewhere.com"
                        />
                        <button type="submit" disabled={busy} data-testid="fp-submit" className="w-full rounded-sm bg-accent-red px-4 py-3 text-sm font-bold uppercase tracking-wider text-white hover:bg-[color:var(--accent-hover)] disabled:opacity-60">
                            {busy ? "Sending…" : "Send reset link"}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
